
    <template>
      <section class="doc-article monkey-view-doc">
        <h1>Image 图片</h1>
<h2 id="dai-ma-shi-li" class="anchor-title">代码示例 <a class="header-anchor" href="#dai-ma-shi-li">#</a></h2>
<code-wrap id="JCYF">
                <template slot="description"><p><code>fit</code>属性和<a href="https://developer.mozilla.org/zh-CN/docs/Web/CSS/object-fit">object-fit</a>保持一致；</p>
</template>
                <template slot="title">基础用法 <a href="#JCYF" data-title="基础用法">#</a></template>
                <template slot="source"><monkey-view-demo0 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;m-image class=&quot;doc-base-image&quot; fit=&quot;none&quot; :src=&quot;src&quot;&gt;&lt;/m-image&gt;
    &lt;m-image class=&quot;doc-base-image&quot; fit=&quot;fill&quot; :src=&quot;src&quot;&gt;&lt;/m-image&gt;
    &lt;m-image class=&quot;doc-base-image&quot; fit=&quot;contain&quot; :src=&quot;src&quot;&gt;&lt;/m-image&gt;
    &lt;m-image class=&quot;doc-base-image&quot; fit=&quot;cover&quot; :src=&quot;src&quot;&gt;&lt;/m-image&gt;
    &lt;m-image class=&quot;doc-base-image&quot; fit=&quot;scale-down&quot; :src=&quot;src&quot;&gt;&lt;/m-image&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
          src: 'http://a3.att.hudong.com/57/28/01300000921826141405283668131.jpg'
        }
      }
    }
&lt;/script&gt;
&lt;style&gt;
.doc-base-image{
  width: 100px;
  height: 100px;
}
&lt;/style&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="JZZHJZSB">
                <template slot="description"><p><code>slot</code>可以自定义加载中和加载失败的展示内容</p>
</template>
                <template slot="title">加载中和加载失败 <a href="#JZZHJZSB" data-title="加载中和加载失败">#</a></template>
                <template slot="source"><monkey-view-demo1 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row&gt;
        &lt;Col&gt;
            &lt;h4&gt;加载中&lt;/h4&gt;
            &lt;m-image class=&quot;doc-status-image&quot; fit=&quot;none&quot; :src=&quot;src1&quot;&gt;&lt;/m-image&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;h4&gt;加载失败&lt;/h4&gt;
            &lt;m-image class=&quot;doc-status-image&quot; fit=&quot;fill&quot; :src=&quot;src2&quot;&gt;&lt;/m-image&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;h4&gt;自定义加载失败&lt;/h4&gt;
            &lt;m-image class=&quot;doc-status-image&quot; fit=&quot;fill&quot; :src=&quot;src2&quot;&gt;
                &lt;Icon slot=&quot;error&quot; type=&quot;picture&quot; class=&quot;doc-status-image-icon&quot;&gt;&lt;/Icon&gt;
            &lt;/m-image&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
          src1: 'http://a3.att.hudong.com/57/28/01300000921826141405283668131.jpg',
          src2: ''
        }
      }
    }
&lt;/script&gt;
&lt;style&gt;
.doc-status-image{
  width: 200px;
  height: 200px;
}
.doc-status-image .doc-status-image-icon{
  font-size: 30px;
}
&lt;/style&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="TPYL">
                <template slot="description"><p><code>preview-list</code>属性开启图片预览功能</p>
</template>
                <template slot="title">图片预览 <a href="#TPYL" data-title="图片预览">#</a></template>
                <template slot="source"><monkey-view-demo2 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;m-image class=&quot;doc-base-image&quot; fit=&quot;none&quot; :src=&quot;src&quot; :preview-list=&quot;list&quot;&gt;&lt;/m-image&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
            src: 'http://a3.att.hudong.com/57/28/01300000921826141405283668131.jpg',
            list: [
                'http://a3.att.hudong.com/57/28/01300000921826141405283668131.jpg',
                'http://a1.att.hudong.com/05/00/01300000194285122188000535877.jpg',
                'https://timgsa.baidu.com/timg?image&amp;quality=80&amp;size=b9999_10000&amp;sec=1593624021279&amp;di=b496016fc934b543036bb4f376caa2da&amp;imgtype=0&amp;src=http%3A%2F%2F00.minipic.eastday.com%2F20161222%2F20161222195407_66e9861db58f43ca5d9a53437a400105_3.jpeg',
            ]
        }
      }
    }
&lt;/script&gt;
&lt;style&gt;
.doc-base-image{
  width: 100px;
  height: 100px;
}
&lt;/style&gt;
</code></pre></div></template></code-wrap>
<h2 id="api" class="anchor-title">API <a class="header-anchor" href="#api">#</a></h2>
<h3 id="image-props" class="anchor-title">Image props <a class="header-anchor" href="#image-props">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>属性</th>
<th>类型</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>fit</td>
<td>String</td>
<td>和<a href="https://developer.mozilla.org/zh-CN/docs/Web/CSS/object-fit">object-fit</a>保持一致</td>
<td>-</td>
</tr>
<tr>
<td>src</td>
<td>String</td>
<td>图片地址</td>
<td>-</td>
</tr>
<tr>
<td>alt</td>
<td>String</td>
<td>原生alt</td>
<td>-</td>
</tr>
<tr>
<td>preview-list</td>
<td>Array</td>
<td>开启图片预览功能，预览图片地址的数组</td>
<td>[]</td>
</tr>
<tr>
<td>zIndex</td>
<td>Number</td>
<td>预览图片蒙版的层级</td>
<td>2000</td>
</tr>
</tbody>
</table>
<h3 id="image-event" class="anchor-title">Image event <a class="header-anchor" href="#image-event">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>事件名</th>
<th>说明</th>
<th>返回值</th>
</tr>
</thead>
<tbody>
<tr>
<td>load</td>
<td>加载成功</td>
<td>e:Event</td>
</tr>
<tr>
<td>error</td>
<td>加载成功失败</td>
<td>e:Event</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "monkey-view-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('m-image',{staticClass:"doc-base-image",attrs:{"fit":"none","src":_vm.src}}),_vm._v(" "),_c('m-image',{staticClass:"doc-base-image",attrs:{"fit":"fill","src":_vm.src}}),_vm._v(" "),_c('m-image',{staticClass:"doc-base-image",attrs:{"fit":"contain","src":_vm.src}}),_vm._v(" "),_c('m-image',{staticClass:"doc-base-image",attrs:{"fit":"cover","src":_vm.src}}),_vm._v(" "),_c('m-image',{staticClass:"doc-base-image",attrs:{"fit":"scale-down","src":_vm.src}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
          src: 'http://a3.att.hudong.com/57/28/01300000921826141405283668131.jpg'
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',[_c('Col',[_c('h4',[_vm._v("加载中")]),_vm._v(" "),_c('m-image',{staticClass:"doc-status-image",attrs:{"fit":"none","src":_vm.src1}})],1),_vm._v(" "),_c('Col',[_c('h4',[_vm._v("加载失败")]),_vm._v(" "),_c('m-image',{staticClass:"doc-status-image",attrs:{"fit":"fill","src":_vm.src2}})],1),_vm._v(" "),_c('Col',[_c('h4',[_vm._v("自定义加载失败")]),_vm._v(" "),_c('m-image',{staticClass:"doc-status-image",attrs:{"fit":"fill","src":_vm.src2}},[_c('Icon',{staticClass:"doc-status-image-icon",attrs:{"slot":"error","type":"picture"},slot:"error"})],1)],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
          src1: 'http://a3.att.hudong.com/57/28/01300000921826141405283668131.jpg',
          src2: ''
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('m-image',{staticClass:"doc-base-image",attrs:{"fit":"none","src":_vm.src,"preview-list":_vm.list}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
            src: 'http://a3.att.hudong.com/57/28/01300000921826141405283668131.jpg',
            list: [
                'http://a3.att.hudong.com/57/28/01300000921826141405283668131.jpg',
                'http://a1.att.hudong.com/05/00/01300000194285122188000535877.jpg',
                'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1593624021279&di=b496016fc934b543036bb4f376caa2da&imgtype=0&src=http%3A%2F%2F00.minipic.eastday.com%2F20161222%2F20161222195407_66e9861db58f43ca5d9a53437a400105_3.jpeg',
            ]
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  